<span class="strength-indicator" *ngIf="strength" [style.--bg]="strengthColorMap[strength]" [class.string-style]="stringStyle">
	{{'password_field.strength_indicator.'+ strength | translate}}
</span>